import { Action, State } from 'modules/cm/store/cases/types';
import { ACTION_TYPES, PepperReview } from './types';

const exportFunc = (state: State, action: Action) => {
  return {
    [ACTION_TYPES.STORE_PEPPER_REVIEW_SUCCESS]: () => ({
      ...state,
      pepperReview: action.payload[0] as PepperReview,
    }),
  };
};

export default exportFunc;
